import { useMemo } from 'react';
import { type SWRResponse } from 'swr';

import { type SwrKey, type UseNoodleSwrConfig, useNoodleSwr } from '@/hooks/useNoodleApi';
import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

const PATH_TEMPLATE = '/filing-review/configs';
type THIS_API = ApiDefinition[typeof PATH_TEMPLATE]['GET'];
type Input = THIS_API['query'];
type Output = THIS_API['response'];

export const useFilingReviewConfigs = (
  params: Input | null,
  config?: UseNoodleSwrConfig<Output>,
): SWRResponse<Output> => {
  const key = useMemo((): SwrKey => {
    if (!params) return null;
    return [PATH_TEMPLATE, { params }];
  }, [params]);

  return useNoodleSwr<Output>(key, { revalidateOnFocus: false, ...config });
};

const listConfigs = async (params: Input): Promise<Output> => {
  const response = await noodleApiClient.get(PATH_TEMPLATE, { params });
  return response.data;
};

export default listConfigs;
